export default __webpack_public_path__ + "static/media/cvod-g.1f7f58cd.svg";